import { AnimatePresence } from 'framer-motion'
import { RacerRow } from './RacerRow'
import type { RaceParticipant } from '../../types'

interface LeaderboardGridProps {
  participants: RaceParticipant[]
  newRecordId?: string
  className?: string
}

export function LeaderboardGrid({
  participants,
  newRecordId,
  className = '',
}: LeaderboardGridProps) {
  const sortedParticipants = [...participants].sort(
    (a, b) => a.current_position - b.current_position
  )

  return (
    <div className={`space-y-3 ${className}`}>
      <AnimatePresence mode="popLayout">
        {sortedParticipants.map((participant, index) => (
          <RacerRow
            key={participant.id}
            participant={participant}
            index={index}
            isNewRecord={participant.id === newRecordId}
          />
        ))}
      </AnimatePresence>
    </div>
  )
}
